import { render, staticRenderFns } from "./BeCustomerCardHorizontal.vue?vue&type=template&id=f240ddde&scoped=true"
import script from "./BeCustomerCardHorizontal.vue?vue&type=script&lang=js"
export * from "./BeCustomerCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./BeCustomerCardHorizontal.vue?vue&type=style&index=0&id=f240ddde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f240ddde",
  null
  
)

export default component.exports